import styled, { keyframes, css } from 'styled-components';

export const GameContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
`;

export const HandContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 20px 0;
`;

export const CardsContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const flipCard = keyframes`
  0% {
    transform: rotateY(0deg);
  }
  100% {
    transform: rotateY(180deg);
  }
`;

export const CardWrapper = styled.div<{ $isNew: boolean; $isFlipping: boolean }>`
  width: 100px;
  height: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  border-radius: 5px;
  perspective: 1000px;
  position: relative;
  ${props => props.$isNew && css`
    animation: ${fadeIn} 0.5s ease-out;
  `}
  ${props => props.$isFlipping && css`
    & > img {
      transition: transform 0.6s;
      transform-style: preserve-3d;
    }
    & > img:first-child {
      transform: rotateY(180deg);
    }
    & > img:last-child {
      transform: rotateY(0deg);
    }
  `}
`;

export const CardImage = styled.img<{ $isFlipped?: boolean }>`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  backface-visibility: hidden;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: transform 0.6s;
  transform-style: preserve-3d;
  transform: ${props => props.$isFlipped ? 'rotateY(180deg)' : 'rotateY(0deg)'};
`;

export const ActionContainer = styled.div`
  margin-top: 20px;
  display: flex;
  gap: 20px; // This will add space between the buttons
`;

export const ActionButton = styled.button`
  padding: 12px 30px; // Increased padding for larger buttons
  color: #fff;
  background-color: #17a2b8;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1.2em; // Increased font size
  font-weight: bold; // Added bold font weight for emphasis
  &:hover {
    background-color: #138496;
  }
  &:disabled {
    background-color: #6c757d;
    cursor: not-allowed;
  }
`;

export const NewGameButton = styled.button`
  padding: 10px 25px;
  font-size: 1.2em;
  color: #fff;
  background-color: #17a2b8;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  &:hover {
    background-color: #138496;
  }
`;

export const GameOverContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
  padding: 20px;
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 8px;
`;

export const ResultMessage = styled.p`
  font-size: 1.2em;
  margin: 10px 0;
  text-align: center;
`;

export const DoubleDownButton = styled(ActionButton)`
  background-color: #28a745;
  &:hover {
    background-color: #218838;
  }
  &:disabled {
    background-color: #6c757d;
  }
`;